import React from 'react';
import { userActions } from 'redux/actions';
import { useDispatch } from 'react-redux';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import useStyles from './styles.js';

const DisabledUser = () => {
	const classes = useStyles();
	const dispatch = useDispatch();

	const handleSignOut = () => {
		dispatch(userActions.logout());
	};

	return (
		// eslint-disable-next-line react/forbid-component-props
		<Box className={classes.componentWrapper}>
			<Box className={classes.disabledUserWrapper}>
				<Typography className={classes.title} align="center">
					Your account has been disabled
				</Typography>
				<Typography display="block" className={classes.text} align="center">
					At this time we are still receiving replies to your account and will save your existing
					messages. Please contact your manager to re-activate your account.
				</Typography>
				<Button className={classes.button} onClick={handleSignOut}>
					Ok
				</Button>
			</Box>
		</Box>
	);
};

export default DisabledUser;
